import React, {useState} from "react";
import {cloneDeep} from "lodash";
import ReactChipInput from "react-chip-input";
import {arrayIncludeItem} from "@app/utils/CommonUtils";
import Select from "react-select";
import {EMPLOYER_NATIONALITIES} from "@app/constants/Nationality";
import {AREA_OPTIONS, PROVINCE_OPTIONS} from "@app/constants/Provinces";
import {BDStatusOption} from "@pages/employer/constant/Constant";

const InitSearchConditions = {
    'keyword_conditions': [
        {field: 'last_name', label: 'Họ', condition: ''},
        {field: 'first_name', label: 'Tên', condition: ''},
        {field: 'origin_company', label: 'Company (TT gốc)', condition: ''},
        {field: 'title', label: 'Title', condition: ''},
        {field: 'company_note', label: 'Company note', condition: ''},
        {field: 'general_note', label: 'General note', condition: ''},
        {field: 'important_note', label: 'Important note', condition: ''},
    ],
    'locations': {
        local_nationality: '', local_ever_work_nationality: '', local_province_email: '', local_area: '', local_area_email: '', local_province: ''
    },
    'cv_content': '',
    'created_date': {
        start_date: '', end_date: ''
    },
    'candidate_id': ''
}

const QuickSearchCandidateInput = (props) => {
    const [searchConditions, setSearchConditions] = useState(cloneDeep(InitSearchConditions));
    const [searching, isSearching] = useState(false);

    const {searchTitle, onChangeQuickSearch, onSearch} = props

    const setSearchConditionItem = (event) => {
        if (event.target.name === 'email' || event.target.name === 'phone') {
            if (!searchConditions.contacts) {
                searchConditions.contacts = {}
            }
            searchConditions.contacts[event.target.name] = event.target.value;
        } else {
            searchConditions[event.target.name] = event.target.value;
        }
        setSearchConditions({...searchConditions});
        onChangeQuickSearch(searchConditions)
    };

    const onSearchEmployers = () => {
        return onSearch(searchConditions)
    }

    const onClearSearchCondition = () => {
        setSearchConditions(cloneDeep(InitSearchConditions));
        onChangeQuickSearch(cloneDeep(InitSearchConditions))
    }

    const onRemoveSpaceEmailPhoneCVContent = (field) => {
        let fieldValue = searchConditions[field];
        if (fieldValue) {
            fieldValue = fieldValue.replaceAll(" ", "")
            searchConditions[field] = fieldValue;
            setSearchConditions({...searchConditions});
        }
    };

    const setSearchKeywordConditions = (values, index) => {
        searchConditions.keyword_conditions[index].condition = values;
        setSearchConditions({...searchConditions});
        onChangeQuickSearch(searchConditions)
    };

    const onRemoveSpaceKeywordConditions = (index) => {
        let searchField = searchConditions.keyword_conditions[index]
        if (searchField.condition) {
            searchField.condition = searchField.condition.replaceAll(" ", "")
            searchConditions.keyword_conditions[index].condition = searchField.condition
            setSearchConditions({...searchConditions});
            onChangeQuickSearch(searchConditions)
        }
    };

    const onChangeLocationCondition = (name, values) => {
        searchConditions.locations[name] = values;
        setSearchConditions({...searchConditions});
        onChangeQuickSearch(searchConditions)
    };

    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">{searchTitle || "Search"}</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
                <div className="card-tools">
                    <button
                        type='button'
                        className='btn btn-default mr-3'
                        onClick={() => onClearSearchCondition()}
                    >
                        {'Clear'}
                    </button>
                    <button
                        type='button'
                        className='btn btn-primary'
                        onClick={() => onSearchEmployers()}
                        disabled={searching}
                    >
                        {searching ? 'Searching...' : 'Search'}
                    </button>
                </div>
            </div>
            <div className="card-body">
                <div className={"row"}>
                    <div className='col-sm-3'>
                        <div className='form-group'>
                            <input type='text' className='form-control' placeholder='Person ID'
                                        value={searchConditions.candidate_id || ''}
                                        name={'candidate_id'}
                                        onChange={event => setSearchConditionItem(event)}/>
                        </div>
                    </div>

                    <div className='col-sm-3'>
                        <div className='form-group'>
                            <input type='text' className='form-control' placeholder='Email'
                                    value={searchConditions.contacts?.email || ''}
                                    name={'email'} onChange={event => setSearchConditionItem(event)}/>
                            <span className={'input-group-append'}>
                                    <button type='button' className='btn btn-warning btn-flat btn-sm'
                                            onClick={() => onRemoveSpaceEmailPhoneCVContent("email")}>
                                        Xóa blanks
                                    </button>
                                </span>
                        </div>
                    </div>
                    <div className='col-sm-3'>
                        <div className='form-group'>
                            <input type='text' className='form-control'
                                    placeholder='SĐT' value={searchConditions.contacts?.phone || ''}
                                    name={'phone'} onChange={event => setSearchConditionItem(event)}/>
                            <span className={'input-group-append'}>
                                    <button type='button' className='btn btn-warning btn-flat btn-sm'
                                            onClick={() => onRemoveSpaceEmailPhoneCVContent("phone")}>
                                        Xóa blanks
                                    </button>
                                </span>
                        </div>
                    </div>
                    {searchConditions.keyword_conditions.length > 0 && searchConditions.keyword_conditions.map((keyword, index) =>
                        <div className='col-sm-3'>
                            <div className='form-group'>
                                <input type='text' className='form-control' placeholder={keyword.label}
                                        value={keyword.condition}
                                        name={keyword.field}
                                        onChange={event => setSearchKeywordConditions(event.target.value, index)}/>
                                {keyword.field !== 'company_note'
                                    && keyword.field !== 'general_note'
                                    && keyword.field !== 'important_note' &&
                                    <span className={'input-group-append'}>
                                        <button type='button' className='btn btn-warning btn-flat btn-sm'
                                                onClick={() => onRemoveSpaceKeywordConditions(index)}>
                                            Xóa blanks
                                        </button>
                                    </span>
                                }
                            </div>
                        </div>
                    )}
                    <div className='col-sm-12'>
                        <div className='input-group'>
                            <label className={'w-100'}><b>Location Miền</b></label>
                            <div style={{width: '100%'}}>
                                <Select options={AREA_OPTIONS} isMulti
                                        value={searchConditions.locations.local_area ? searchConditions.locations.local_area : ''}
                                        onChange={value => {
                                            onChangeLocationCondition('local_area', value);
                                        }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-12 mt-3'>
                        <div className='form-group'>
                            <label className='card-title text-bold'>Search nội dung file CV</label>
                            <input type='text' className='form-control' placeholder='Nhập nội dung search'
                                    value={searchConditions.cv_content}
                                    name={'cv_content'} onChange={event => setSearchConditionItem(event)}/>
                            <span className={'input-group-append'}>
                                <button type='button' className='btn btn-warning btn-flat btn-sm'
                                        onClick={() => onRemoveSpaceEmailPhoneCVContent('cv_content')}>
                                    Xóa blanks
                                </button>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Search nội dung file CV</h3>
                </div>
                <div className='card-body row'>
                    <div className='col-sm-12'>
                        <div className='form-group'>
                            <input type='text' className='form-control' placeholder='Nhập nội dung search'
                                    value={searchConditions.cv_content}
                                    name={'cv_content'} onChange={event => setSearchConditionItem(event)}/>
                            <span className={'input-group-append'}>
                                    <button type='button' className='btn btn-warning btn-flat btn-sm'
                                            onClick={() => onRemoveSpaceEmailPhoneCVContent('cv_content')}>
                                        Xóa blanks
                                    </button>
                                </span>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default QuickSearchCandidateInput;
